import { render, staticRenderFns } from "./matchingResults_cpa.vue?vue&type=template&id=8514ee34&scoped=true"
import script from "./matchingResults_cpa.vue?vue&type=script&lang=js"
export * from "./matchingResults_cpa.vue?vue&type=script&lang=js"
import style0 from "./matchingResults_cpa.vue?vue&type=style&index=0&id=8514ee34&prod&lang=css"
import style1 from "./matchingResults_cpa.vue?vue&type=style&index=1&id=8514ee34&prod&scoped=true&lang=css"
import style2 from "./matchingResults_cpa.vue?vue&type=style&index=2&id=8514ee34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8514ee34",
  null
  
)

export default component.exports